<template>
  <BovineSearch
    @search="$emit('search', $event)"
    :cache="true"
    :cacheKey="cacheKey"
  ></BovineSearch>
</template>

<script>
import BovineSearch from './BovineSearch.vue';

export default {
  name: 'BovineSearchBar',
  components: {
    BovineSearch,
  },
  data() {
    return {
      cacheKey: 'BovineListFilter',
      ready: false,
    };
  },
  beforeMount() {
    if (!this.$route.params.cacheFilter) {
      localStorage.removeItem(this.cacheKey);
    }
  },
};
</script>

<style>
</style>
